module.exports = __webpack_public_path__ + "static/media/emj05.5289c77a.svg";